<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { appHapticFeedbackSoft } from "@/utils/common";
import { useUserStore } from "@/store/user";
import { useConfigStore } from "@/store/config";
const userStore = useUserStore();

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
let configStore = useConfigStore();

// 新增：检测是否有底部横杆
const hasHomeIndicator = ref(false);

// Filter routes with isTabbar meta
const allTabber = computed(() =>
  router.getRoutes().filter((route) => route.meta.isTabbar)
);

// Use computed property for current path
const currentPath = computed(() => route.path);

// Computed property to determine if tabbar should be shown
const showTabbar = computed(() => {
  // 必须先通过404初始化，才允许显示Tabbar
  if (!configStore.hasPassedInit) {
    return false;
  }
  // 通过初始化后，根据路由 meta 判断是否显示
  // 如果路由 meta 中 showTabbar 为 false，则不显示
  return route.meta.showTabbar !== false;
});

const go = (path) => {
  appHapticFeedbackSoft();
  router.push(path);
};
onMounted(() => {
  // 在 meta viewport 中添加 viewport-fit=cover
  const metaViewport = document.querySelector('meta[name="viewport"]');
  if (metaViewport) {
    let content = metaViewport.getAttribute("content") || "";
    if (!content.includes("viewport-fit=cover")) {
      metaViewport.setAttribute("content", content + ",viewport-fit=cover");
    }
  }

  // 使用 CSS 环境变量检测
  const safeAreaBottom =
    getComputedStyle(document.documentElement).getPropertyValue(
      "--sal-safe-area-inset-bottom"
    ) ||
    getComputedStyle(document.documentElement).getPropertyValue(
      "env(safe-area-inset-bottom)"
    ) ||
    "0px";

  hasHomeIndicator.value = parseInt(safeAreaBottom) > 0;

  // 如果上面的方法失败，使用设备检测作为备选方案
  if (!hasHomeIndicator.value) {
    // iOS 检测
    const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
    if (isIOS) {
      // iPhone X 或更新的设备（屏幕高度大于等于812px）
      const height = window.screen.height;
      const width = window.screen.width;
      const maxDimension = Math.max(height, width);
      hasHomeIndicator.value = maxDimension >= 812;
    }
  }
});
watch(hasHomeIndicator, (newVal) => {
  configStore.setDATA({
    hasHomeIndicator: newVal,
  });
});
// :class="{
//   bottomNone: configStore.is_full_screen && !hasHomeIndicator,
//   hasHomeIndicator: !configStore.is_full_screen && hasHomeIndicator,
// }"
</script>

<template>
  <nav v-if="showTabbar" class="tabbar">
    <div v-for="item in allTabber" :key="item.path" @click="go(item.path)" class="item"
      :class="{ active: currentPath === item.path }">
      <img :src="currentPath === item.path ? item.meta.activeIcon : item.meta.icon"
        :alt="t(`message.${item.meta.title}`)" />
      <div class="text">
        {{ t(`message.${item.meta.title}`) }}
      </div>
    </div>
  </nav>
</template>

<style scoped lang="scss">
@supports (padding: env(safe-area-inset-bottom)) {
  .hasHomeIndicator {
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
}

.bottomNone {
  padding-bottom: 10px !important;
}

.hasHomeIndicator {
  padding-bottom: 30px !important;
}

.tabbar {
  position: fixed;
  left: 0;
  right: 0;
  width: calc(100%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  bottom: 0px;
  z-index: 2;
  box-sizing: border-box;
  //border-radius: 4px;
  background-color: #ffffffe8;
  backdrop-filter: blur(6px);
  padding-bottom: calc(15px - var(--tg-content-safe-area-inset-bottom) - var(--tg-safe-area-inset-bottom));
  padding-top: 15px;

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 13vw;

    img {
      height: 3vh;
      width: 3vh;
      margin-bottom: 5px;
    }

    .text {
      color: #71717a;
    }

    &.active .text {
      color: black;
    }
  }
}
</style>
